import { apiFetch } from "./api";

export type ModuleRoleDefinition = {
  role: string;
  label: string;
};

// Registro dos módulos que definem cargos próprios (além do vínculo comum
// usuário-empresa-módulo). O backend não interpreta esses valores - são
// strings opacas por módulo (ver internal/services/module_role.go) - então
// cada módulo/papel novo entra aqui e o formulário do usuário já passa a
// exibir o checkbox correspondente, sem precisar de mais nenhuma mudança.
// O valor de "role" precisa bater exatamente com o que o produto confere
// (ex.: creatorRole em app-dono-product-runtime/internal/metas/cenarios.go).
export const MODULE_ROLES: Record<string, ModuleRoleDefinition[]> = {
  metas: [{ role: "Criador de Meta", label: "Criador de meta" }],
};

export type ModuleRoleData = {
  user_id: string;
  client_id: string;
  module_id: string;
  role: string;
};

export type ModuleRoleGrant = {
  user_id: string;
  role: string;
};

export function getModuleRoles(userId: string, clientId: string, moduleId: string) {
  const params = new URLSearchParams({ user_id: userId, client_id: clientId, module_id: moduleId });
  return apiFetch<{ roles: string[] }>(`/api/module-roles?${params.toString()}`);
}

// Todos os grants de um módulo no client, de todos os usuários (aba Permissões da Escala).
export function listModuleRoleGrants(clientId: string, moduleId: string) {
  const params = new URLSearchParams({ client_id: clientId, module_id: moduleId });
  return apiFetch<{ grants: ModuleRoleGrant[] }>(`/api/module-roles?${params.toString()}`).then(
    (r) => r.grants ?? [],
  );
}

export function grantModuleRole(data: ModuleRoleData) {
  return apiFetch<void>("/api/module-roles", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function revokeModuleRole(data: ModuleRoleData) {
  const params = new URLSearchParams(data);
  return apiFetch<void>(`/api/module-roles?${params.toString()}`, {
    method: "DELETE",
  });
}
